import React from "react";
import { useGlobalContext } from "../../context";
import Entry from "./Entry";

const initialUserData = {
  id: "",
  fullName: "",
  username: "",
  password: "",
  entries: [],
  idNumber: "",
};

const UserForm = ({ setLoading, updateUsers, userData, exams }) => {
  const { apiClient } = useGlobalContext();
  const [user, setUser] = React.useState(userData || initialUserData);
  const [entries, setEntries] = React.useState(
    userData ? userData.entries : []
  );
  const [exam, setExam] = React.useState("");
  const [startDate, setStartDate] = React.useState("");
  const [registrationDate, setRegistrationDate] = React.useState("");
  const closeButtonRef = React.useRef(null);

  function resetStates() {
    setUser(userData || initialUserData);
    setEntries(userData ? userData.entries : []);
    setExam("");
  }

  function updateUser(e) {
    setUser({ ...user, [e.target.name]: e.target.value });
  }
  function deleteEntry(id) {
    setEntries(entries.filter((e) => e.id !== id));
  }
  function addEntry() {
    const examToAdd = exams.find((e) => e.id === exam);
    if (!examToAdd) return;
    const entry = {
      id: Date.now(),
      examName: examToAdd.name,
      exam: examToAdd.id,
      startDate: new Date(startDate.replace(/-/g, "/")),
      registrationDate: registrationDate,
      status: "pending",
      date: "",
      grade: 0,
    };
    // const [y, m, d] = startDate.split("-");
    // entry.startDate.setFullYear(y);
    // entry.startDate.setMonth(m - 1);
    // entry.startDate.setDate(d);
    // entry.startDate = new Date(startDate).toISOString();
    setEntries([...entries, entry]);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    try {
      setLoading(true);
      const payload = {};

      if (!user.username) {
        alert("Error: Username is required.");
        return;
      } else {
        payload.username = user.username.toLowerCase().trim();
      }
      if (!userData && !user.password) {
        alert("Error: Password is required.");
        return;
      } else if (user.password) {
        payload.password = user.password;
      }

      payload.idNumber = user.idNumber;
      payload.fullName = user.fullName;
      payload.email = `${user.username}@mail.com`;

      payload.entries = entries.map((e) => ({
        examName: e.examName,
        exam: e.exam,
        status: e.status,
        date: e.date,
        startDate: e.startDate,
        registrationDate: e.registrationDate,
        grade: e.grade,
      }));

      if (!userData) {
        setUser(initialUserData);
        closeButtonRef.current.click();
      }
      let res;
      if (userData) {
        res = await apiClient.put(`/users/${user.id}`, payload);
      } else {
        res = await apiClient.post("/users", payload);
      }
      updateUsers(res.data);
    } catch (error) {
      alert(error);
      console.log(error.response.data);
    } finally {
      setLoading(false);
    }
  }

  return (
    <>
      <div
        className={`btn btn-sm btn-${userData ? "warning" : "primary"}`}
        data-bs-toggle="modal"
        data-bs-target={`#userFormModal${user.id}`}
      >
        {userData ? "Edit" : "Add New"}
      </div>
      <div
        className="modal fade"
        id={`userFormModal${user.id}`}
        tabIndex="-1"
        aria-labelledby="addModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="addModalLabel">
                {userData ? "Update Student" : "Create New Student"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                ref={closeButtonRef}
                onClick={resetStates}
              ></button>
            </div>
            <form onSubmit={handleSubmit}>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="name-input" className="form-label">
                    <h6 className="m-0">Full Name</h6>
                  </label>
                  <input
                    type="text"
                    id="name-input"
                    className="form-control form-control-sm"
                    placeholder="optional"
                    name="fullName"
                    value={user.fullName}
                    onChange={updateUser}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="email-input" className="form-label">
                    <h6 className="m-0">Username</h6>
                  </label>
                  <input
                    type="text"
                    id="username-input"
                    className="form-control form-control-sm"
                    required={true}
                    name="username"
                    value={user.username}
                    onChange={updateUser}
                  />
                  <span className="form-text">
                    Use only letters and numbers.
                  </span>
                </div>

                <div className="mb-3">
                  <label htmlFor="password-input" className="form-label">
                    <h6 className="m-0">Password</h6>
                  </label>
                  <input
                    type="text"
                    id="password-input"
                    className="form-control form-control-sm"
                    placeholder={userData ? "optional" : ""}
                    required={userData ? false : true}
                    name="password"
                    value={user.password}
                    onChange={updateUser}
                  />
                </div>
                <div className="mb-3">
                  <label htmlFor="id-input" className="form-label">
                    <h6 className="m-0">Identification Number</h6>
                  </label>
                  <input
                    type="text"
                    id="id-input"
                    className="form-control form-control-sm"
                    name="idNumber"
                    value={user.idNumber}
                    onChange={updateUser}
                  />
                </div>
                <h6 className="mb-0">Exams</h6>
                <table className="table table-sm ">
                  <thead>
                    <tr>
                      <th className="text-muted">Name</th>
                      <th className="text-muted">Status</th>
                      <th className="text-muted">Reg Date</th>
                      <th className="text-muted">Eligibility Date</th>
                      <th className="text-muted">Grade</th>
                    </tr>
                  </thead>
                  <tbody>
                    {entries.map((e) => (
                      <Entry key={e.id} entry={e} deleteEntry={deleteEntry} />
                    ))}
                  </tbody>
                </table>
                <div className="row g-2 align-items-end">
                  <div className="col-6 col-lg-3">
                    <label htmlFor="exam-select">Exam</label>
                    <select
                      id="exam-select"
                      className="form-select form-select-sm"
                      value={exam}
                      onChange={(e) => setExam(e.target.value)}
                    >
                      <option value="" key="0">
                        Select Exam
                      </option>
                      {exams.map((e) => (
                        <option value={e.id} key={e.id}>
                          {e.name}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="col-6 col-lg-3">
                    <label htmlFor="registration-date-input">
                      Registration Date
                    </label>
                    <input
                      id="registration-date-input"
                      type="date"
                      className="form-control form-control-sm"
                      value={registrationDate}
                      onChange={(e) => setRegistrationDate(e.target.value)}
                    />
                  </div>
                  <div className="col-6 col-lg-3">
                    <label htmlFor="start-date-input">Activation Date</label>
                    <input
                      id="start-date-input"
                      type="date"
                      className="form-control form-control-sm"
                      value={startDate}
                      onChange={(e) => setStartDate(e.target.value)}
                    />
                  </div>
                  <div className="col-6 col-lg-3">
                    <button
                      type="button"
                      className="btn btn-sm btn-primary w-100"
                      onClick={addEntry}
                    >
                      Add Exam
                    </button>
                  </div>
                </div>
              </div>
              <div className="d-flex p-3 justify-content-end">
                <button
                  type="button"
                  className="btn btn-sm btn-outline-secondary"
                  data-bs-dismiss="modal"
                  onClick={resetStates}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn btn-sm btn-success px-4 ms-2"
                  data-bs-dismiss={userData ? "modal" : ""}
                >
                  {userData ? "Update Student" : "Create Student"}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserForm;
